import React from 'react';
import { useTranslation } from 'react-i18next';
import { GraduationCap } from 'lucide-react';
import { SiteLayout, useDocumentTitle } from '../components/platform/SiteLayout';
import { Container, Heading, CardSkeletons, EmptyState, ErrorState } from '../components/platform/ui';
import { CourseCard } from './CabinetPage';
import useAsync from '../hooks/useAsync';
import { platformApi } from '../services/platformApi';
import { useAuth } from '../contexts/AuthContext';

const WebinarsPage = () => {
  const { t, i18n } = useTranslation();
  useDocumentTitle(t('pl.courses.title'));
  const { user } = useAuth();
  const { data, loading, error, reload } = useAsync(platformApi.courses, [user?.id, i18n.language]);
  return (
    <SiteLayout>
      <Container className="py-12">
        <Heading level={1} className="text-4xl sm:text-5xl mb-3">{t('pl.courses.title')}</Heading>
        <p className="text-gray-700 max-w-3xl mb-10">{t('pl.courses.subtitle')}</p>
        {loading ? <CardSkeletons /> : error ? <ErrorState onRetry={reload} /> : data.length === 0 ? (
          <EmptyState icon={GraduationCap} title={t('pl.courses.emptyTitle')} text={t('pl.courses.emptyText')} />
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">{data.map((c) => <CourseCard key={c.id} c={c} />)}</div>
        )}
      </Container>
    </SiteLayout>
  );
};

export default WebinarsPage;
